import './new.notes.scss';

import { Alert, AlertTitle, Avatar, Box, Grid, Stack } from '@mui/material';
import {
  CreateNoteTargetInput,
  NoteTargetAreaType,
  NotesListData,
  getPaginatedNodes,
  useGetNotes,
} from '@converge/graphql';

import { NewNoteCreateForm } from './new.note.create.form';
import { NewNoteList } from './new.note.list';
import { NotesHeader } from './new.notes.header';
import Warning from '@mui/icons-material/Warning';
import { useAuthContext } from '../auth';

export interface INewNotesProps extends CreateNoteTargetInput {
  data?: NotesListData;
  title: string;
  hideHeader?: boolean;
  containerWidth?: number;
  testId?: string;
  inputTestId?: string;
  buttonTestId?: string;
  targetArea?: NoteTargetAreaType;
  targetSubUuid?: string | null | undefined;
  targetSubName?: string | null | undefined;
  label?: string[] | null | undefined;
  onClose?: () => void;
  showBtn?: boolean | undefined;
  callHandleUpdateRenewalType?: () => void;
  disabled?: boolean;
}
///
export const NewConvergeNotes = ({
  title,
  data,
  hideHeader,
  targetName,
  targetType,
  targetUuid,
  containerWidth,
  testId,
  inputTestId,
  buttonTestId,
  targetArea,
  targetSubUuid,
  targetSubName,
  label,
  showBtn,
  onClose,
  callHandleUpdateRenewalType,
  disabled,
}: INewNotesProps) => {
  const { notes } = useGetNotes({
    targetUuid,
    targetType,
    targetName,
    targetArea,
    targetSubUuid,
    targetSubName,
    label,
  });
  const { user } = useAuthContext();

  return (
    <Grid
      className="note-container"
      item
      xs={12}
      md={containerWidth}
      data-testid={testId}
    >
      {!hideHeader && <NotesHeader title={title} />}
      <Stack className="node-form-container">
        <Box className="node-avatar">
          <Avatar className="avatar-icon">
            {' '}
            {user?.user.username?.slice(0, 2).toUpperCase()}
          </Avatar>
        </Box>
        <Box className="node-form">
          <NewNoteCreateForm
            showBtn={showBtn}
            onClose={onClose}
            targetUuid={targetUuid}
            targetType={targetType}
            targetName={targetName}
            targetSubUuid={targetSubUuid}
            targetArea={targetArea}
            label={label ? label[0] : ''}
            disabled={disabled}
            inputTestId={inputTestId}
            buttonTestId={buttonTestId}
          />
        </Box>
      </Stack>
      {data || notes ? (
        <NewNoteList notes={notes ? notes : getPaginatedNodes(data)} />
      ) : (
        <Alert icon={<Warning />} color="error" className="alert-container">
          <AlertTitle sx={{ margin: 0 }}>
            The Converge API is not returning notes
          </AlertTitle>
        </Alert>
      )}
    </Grid>
  );
};
